import Button from "../customComponents/Button";
import Paper from "../widgets/Paper";
import InputText from "../customComponents/InputText";
import Select from "../customComponents/Select";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { post } from "../utils/api";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "../customComponents/DatePicker";

const EditAssignedInstitution = () => {
  const [dropdownDataLoaded, setDropdownDataLoaded] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [assignedInstitution, setAssignedInstitution] = useState([]);
  const [entries, setEntries] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const { assignInfo } = location.state || {};
  const isEdit = location.state?.isEdit;

  useEffect(() => {
    const fetchAllOptions = async () => {
      try {
        await Promise.all([
          fetchOptions({ type: "status" }),
          fetchOptions({ type: "institution" }),
        ]);
        setDropdownDataLoaded(true);
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    };

    fetchAllOptions();
  }, []);

  const fetchOptions = async (value) => {
    try {
      const result = await post("/getOptionList", value);
      if (value.type === "institution") {
        // convert to {label, value}
        const instOptions = result.data.map((inst) => ({
          label: inst.label,
          value: inst.institutionid,
        }));
        setAssignedInstitution(instOptions);
      } else {
        const statusOpts = result.data.map((s) => ({
          label: s.label || s.statusname || s.value,
          value: s.value || s.id,
        }));
        setStatusOptions(statusOpts);
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };
  // Prepopulate data if editing
  useEffect(() => {
    if (isEdit && dropdownDataLoaded) {
      setEntries(
        assignInfo?.assigned_institutions?.map((item) => ({
          institutionid: item.institutionid,
          date: item.assignedins_plan[0]?.date ? new Date(item.assignedins_plan[0]?.date) : new Date(),
          statusid: item.statusid,
          remarks: item.remarks || "",
          institutionName:item.institutionName
        })) || []
      );
    }
  }, [dropdownDataLoaded, isEdit]);
  console.log("inistopt", entries);

  const updateEntry = (index, field, value) => {
    const updatedEntries = [...entries];
    updatedEntries[index][field] = value;
    setEntries(updatedEntries);
  };

  const addEntry = () => {
    setEntries([
      ...entries,
      { institutionid: "", date: new Date(), statusid: "", remarks: "" },
    ]);
  };

  const deleteEntry = (index) => {
    const updatedEntries = entries.filter((_, i) => i !== index);
    setEntries(updatedEntries);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...assignInfo,
        assigned_institutions: entries,
      };

      const response = await post("/updateAssignedInstitution", payload);
      if (response.status) {
        toast.success("Assigned institutions updated successfully!");
        navigate("/assigned-institution");
      }
    } catch (error) {
      toast.error("Failed to update institution: " + error.message);
    }
  };

  return (
    <div>
      <div className="flex justify-between">
        <h2 className="text-primary-black text-[24px] font-semibold">
          Edit Assigned Institution
        </h2>

        <div className="flex gap-4">
          <Button
            type="secondary"
            onClick={() => navigate("/assigned-institution")}
            label="Cancel"
          />
          <Button type="primary" onClick={handleUpdate} label="Update" />
        </div>
      </div>

      <Paper className="my-8 pt-6 pb-6">
        <Paper className="my-8 border">
          <h1 className="text-[20px] font-bold pt-6">Visited Status</h1>
          <div className="grid grid-cols-1 gap-2 pt-2">
            {/* Sales Person info */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="text-[16px] font-semibold">
                  Sales Person
                </label>
                <InputText value={assignInfo.username} disabled={true} />
              </div>
            </div>
            {/* Dynamic entries */}
            {entries.map((entry, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 items-center border-b py-4"
              >
                {/* Institution */}
                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    Assigned Institution
                  </label>
                  <Select
                    options={assignedInstitution}
                  value={assignedInstitution.find(item=>item.value===entry.institutionid)}
                    onChange={(val) =>
                      updateEntry(index, "institutionid", val.value)
                    }
                    placeholder="Select institution..."
                    disabled
                  />
                </div>

                {/* Date */}
                <div>
                  <label className="text-[16px] font-semibold">Date</label>
                  <DatePicker
                    selectedDate={entry.date}
                    onDateChange={(date) => updateEntry(index, "date", date)}
                    placeholderText="Select Date..."
                  />
                </div>

                {/* Status */}
                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    Status
                  </label>
                  <Select
                    options={statusOptions}
                    value={statusOptions.find(
                      (s) => s.value === entry.statusid
                    )}
                    onChange={(val) =>
                      updateEntry(index, "statusid", val.value)
                    }
                    placeholder="Select status..."
                  />
                </div>

                {/* Remarks */}
                <div>
                  <label className="text-[16px] font-semibold">Remarks</label>
                  <textarea
                    className="w-full h-[60px] p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Remark..."
                    value={entry.remarks}
                    onChange={(e) =>
                      updateEntry(index, "remarks", e.target.value)
                    }
                  />
                </div>

                {/* Actions */}
                {/* <div className="flex gap-2 mt-6 ml-6">
                  {index < entries.length - 1 && (
                    <button
                      className="p-2 rounded bg-red-500 text-white"
                      onClick={() => deleteEntry(index)}
                    >
                      <span className="material-symbols-outlined">delete</span>
                    </button>
                  )}
                  {index === entries.length - 1 && (
                    <button
                      className="p-2 rounded bg-black text-white"
                      onClick={addEntry}
                    >
                      <span className="material-symbols-outlined">add</span>
                    </button>
                  )}
                </div> */}
              </div>
            ))}
          </div>
        </Paper>
      </Paper>
    </div>
  );
};

export default EditAssignedInstitution;
